import React from 'react';
import
    {
        Button,
        Dialog,
        DialogContent,
        DialogContentText,
        DialogTitle,
        DialogActions,

    } from '@mui/material';

const DeleteConnectionDialog = (props) =>
{

    const onClick = (value) =>
    {

        if (value === "cancel")
        {
            props.onCancelClick(false);
        }
        else if (value === "ok")
        {
            props.handleCnfClick();
        }
    }

    return (
        <div>
            <Dialog id="DeleteConnectionDialog"
                open={props.open}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                maxWidth={'xs'}
            >
                {props.title ?
                    <DialogTitle id="alert-dialog-title">
                        {props.title}
                    </DialogTitle> : null
                }
                <DialogContent>
                    <DialogContentText id="alert-dialog-description" >
                        {props.message}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => onClick("cancel")} color="primary">
                        {props.CancelButtonText}
                    </Button>
                    <Button onClick={() => onClick("ok")} autoFocus>
                        {props.OkButtonText}
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}

export default DeleteConnectionDialog;

DeleteConnectionDialog.defaultProps = {
    CancelButtonText: "Cancel",
    OkButtonText: "OK",
    title: '',
    message: ''
}